import { makeAutoObservable } from 'mobx'
import posthog from 'posthog-js'
import { LandingLeadModel } from '@/features/landing/model/landing-lead.model'
import type { LandingLeadFormValues } from '@/features/landing/model/landing-lead-form.schema'
import { LandingPageModel } from '@/features/landing/model/landing-page.model'
import type { LandingPageId } from '@/shared/config/site'
import { gtmEvent } from '@/shared/lib/googleTag'

export class LandingPageViewmodel {
  public readonly page: LandingPageModel
  public lastLead: LandingLeadModel | null = null

  public constructor(pageId: LandingPageId) {
    this.page = new LandingPageModel(pageId)

    makeAutoObservable(this, {}, { autoBind: true })
  }

  public get hasSubmittedLead(): boolean {
    return this.lastLead !== null
  }

  public init(): void {
    this.syncDocumentTitle()
    gtmEvent('landing_page_view', {
      landing_page: this.page.id,
      page_path: this.page.path,
    })
  }

  public captureLead(values: LandingLeadFormValues): void {
    const lead = new LandingLeadModel(this.page, values)

    this.lastLead = lead

    gtmEvent('landing_lead_intent', {
      email_domain: lead.emailDomain,
      landing_page: this.page.id,
      page_path: this.page.path,
    })
    posthog.capture('landing_lead_captured', {
      email_domain: lead.emailDomain,
      landing_page: this.page.id,
      page_path: this.page.path,
    })

    openMailDraft(lead.mailtoHref)
  }

  public dispose(): void {
    this.lastLead = null
  }

  public syncDocumentTitle(documentTitle = this.page.content.documentTitle): void {
    document.title = documentTitle
  }
}

function openMailDraft(mailtoHref: string): void {
  try {
    window.location.href = mailtoHref
  } catch {
    // Some non-browser environments cannot navigate to mailto links.
  }
}
